import React, { useState, useEffect } from "react";

import Autocomplete from "../ui/Autocomplete";
import NuxeoClient from "../../clients/NuxeoClient";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";

import { useI18n } from "../../I18nProvider";

export default function Chacaters(props) {
  const appText = useI18n();
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    _loadCharacters();
  }, [props.propertyID]);

  async function _loadCharacters() {
    await NuxeoClient.instance()
      .fetchCharacters(props.propertyID)
      .then((response) => {
        //Move `No Reportable Elements` to bottom of list
        response.push(
          response.splice(
            response.findIndex(
              (index) => index.label === "No Reportable Elements"
            ),
            1
          )[0]
        );
        setFetchedData(response);
        setIsLoading(false);
      });
  }

  const handleChange = (characters) => {
    if (characters === null) {
      props.handleChange("characters", []);
      props.handleChange("charactersID", []);
    } else if (characters.length > props.value.length) {
      let values = [...props.value];
      values.push(characters[characters.length - 1].label);
      props.handleChange("characters", values);

      let ids = [...props.id];
      ids.push(characters[characters.length - 1].id);
      props.handleChange("charactersID", ids);
    } else {
      const charactersLabels = characters.map(
        (character) => (character = character.label)
      );
      const deletedCharacter = props.value.filter(
        (value) => !charactersLabels.includes(value)
      );

      let deletedIndex;
      let values = [...props.value];
      props.value.forEach((value, index) => {
        if (value === deletedCharacter[0]) {
          deletedIndex = index;
          values.splice(index, 1);
        }
      });
      props.handleChange("characters", values);

      let ids = [...props.id];
      ids.splice(deletedIndex, 1);
      props.handleChange("charactersID", ids);
    }
  };

  return (
    // <Tooltip arrow title="Please, list all characters included in this submission">
    <Tooltip arrow title={appText.T133}>
      <Grid item={true} xs={12}>
        <div id="characters">
          <InputLabel
            className="field-label field-dropdown"
            required={props.type === "publishing" ? false : true}
          >
            {/* Characters */}
            {appText.T86}
          </InputLabel>
          <Autocomplete
            type={"multi"}
            handleChange={handleChange}
            data={fetchedData}
            dataType={"characters"}
            mapVariable={"label"}
            value={props.value}
            isLoading={isLoading}
          />
          {/* <small><i>Please note that the dropdown will only display the first 20 assets; in order to see additional assets, you will need to type and search the field for the STAR LABS assets you are looking for. If you cannot find the right characters for this submission, you may select "No Reportable Elements."</i></small> */}
          <small>
            <i>{appText.T87}</i>
          </small>
        </div>
      </Grid>
    </Tooltip>
  );
}
